// React
import { useContext } from "react"

// Components
import { Select } from "components"

// Contexts
import { AccountContext } from "contexts"

// Form
import { Controller, useFormContext } from "react-hook-form"

// Types
import type { FormType } from "../utils"

export function Account(): JSX.Element {
  // Hooks
  const { data, isLoading } = useContext(AccountContext)

  // Form
  const { control } = useFormContext<FormType>()

  return (
    <Controller
      name="coa_id"
      control={control}
      render={({ field, fieldState }) => (
        <Select
          label="PAYMENT FROM ACCOUNT"
          placeholder="Select Account"
          isLoading={isLoading}
          options={data}
          error={fieldState.error?.message}
          onChange={e => {
            if (e) {
              field.onChange(e.value)
            }
          }}
        />
      )}
    />
  )
}